module.exports = __webpack_public_path__ + "static/img/p4.e78b687.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/p4.png
// module id = 9ZDc
// module chunks = 1